export var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["Predict"] = 0] = "Predict";
    CustomerType[CustomerType["Broker"] = 1] = "Broker";
    CustomerType[CustomerType["WhiteLabel"] = 2] = "WhiteLabel";
})(CustomerType || (CustomerType = {}));
